/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UserProvider } from 'src/app/providers';
import { User } from 'src/app/model';
import { InputType } from 'src/app/model/enums/input.type';
import { CrmAlertComponent } from '../../fields';
import { UserService, AccountService } from '../../../services';

@Component({
  selector: 'page-account',
  templateUrl: 'account.page.html',
  styleUrls: ['account.page.scss']
})

export class AccountPage implements OnInit{
  @ViewChild('alert') alert: CrmAlertComponent;

  typeOfInput = InputType;
  isLoading = false;
  currentUrl: string;

  constructor(
    private router: Router,
    private userProvider: UserProvider,
    private userService: UserService,
    private accountService: AccountService
  ) {
    router.events
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          if (event.urlAfterRedirects.endsWith('profile')) {
            this.currentUrl = 'profile';
          } else if (event.urlAfterRedirects.endsWith('preferences')) {
            this.currentUrl = 'preferences';
          } else if (event.urlAfterRedirects.endsWith('notification')) {
            this.currentUrl = 'notification';
          }
        }
      });
  }

  ngOnInit(): void {
    this.userProvider.getMyProfile()
      .subscribe(data => {
        if (data.success) {
          this.userService.setUser(User.parse(data.result));
        }
      });
  }

  onChangePassword(): void {
    this.accountService.onChangePassword.emit();
  }

  onSave(): void {
    this.accountService.onSave.emit();
  }

  onSavePreference(): void {
    this.accountService.onSavePreferences.emit();
  }

  onSaveNotification(): void {
    this.accountService.onSaveNotification.emit();
  }
}
